import { apiClient } from '@repo/shared';

const saveTheme = async(theme) => {
  var returnedThemes;
  if (theme.id.startsWith('t')) {
    //It's a new theme
    returnedThemes = await apiClient.post(`/api/themes`, theme);
  } else {
    //Updating an existing theme
    console.log('saving theme', theme);
    returnedThemes = await apiClient.post(`/api/themes/${theme.id}`, theme);
  }
  return returnedThemes;
};

const deleteTheme = async(id) => {
  const returnedThemes = await apiClient.delete(`/api/themes/${id}`);
  return returnedThemes;
};

const getThemes = async() => {
  console.log('In getThemes');
  const themes = await apiClient.get(`/api/themes`);
  return themes;
};

const uploadMaterial = async(material) => {
  const returnedMaterials = await apiClient.uploadFile('/api/content', material);
  return returnedMaterials;
};

const saveMaterial = async(material) => {
  const returnedMaterials = await apiClient.post(`/api/materials/${material.id}`, material);
  return returnedMaterials;
};

const generatePdf = async(details) => {
  const generatedPdf = await apiClient.post(`/api/pdf`, details, { responseType: 'blob' });
  const data = await generatedPdf?.data;
  return data;
};

const getMaterials = async(filter) => {
  const url = `/materials`;
  console.log('In getMaterials', url);
  const materials = await apiClient.get(`/api${url}`);
  return materials;
};

const getMaterialsAsClassThemesMap = async(classId) => {
  const url = `/materials/astheme?classId=${classId}`;
  console.log('In getMaterialsAsClassThemesMap', url);
  const materials = await apiClient.get(`/api${url}`);
  return materials;
};

const deleteMaterial = async(id) => {
  const returnedMaterials = await apiClient.delete(`/api/materials/${id}`);
  return returnedMaterials;
};


const PlanService = {
  saveTheme,
  getThemes,
  deleteTheme,
  uploadMaterial,
  saveMaterial,
  getMaterials,
  getMaterialsAsClassThemesMap,
  deleteMaterial,
  generatePdf,
};

export default PlanService;